<template>
  <GenericListSubHeader :text="label" :previewable="false" :showCheckbox="false" :isChecked="false" color="#f3f3f3"
    :toggleCheckbox="() => toggleSelected()" @PrimaryClick="toggleHideBy()">
    <v-row no-gutters align="center">
      <v-col class="px-3" cols="0">
        {{ label }}
      </v-col>
      <v-col cols="auto">
        <v-btn icon class="mx-1" @click.stop="toggleHideBy()">
          <v-icon v-text="!hideByKey ? 'mdi-chevron-up' : 'mdi-chevron-down'"></v-icon>
        </v-btn>
      </v-col>
    </v-row>
  </GenericListSubHeader>
</template>

<script>
import GenericListSubHeader from "@/components/ListItems/GenericListSubHeader.vue";

export default {
  name: 'EmploymentSubHeader',
  props: {
    /** When two-layer (date->tech), provide the date; otherwise omit */
    date: [String, Date],
    /** The employmentId key */
    employmentId: { type: String, default: '' },
    /** Display label (usually the employment.Name) */
    label: { type: String, default: '' },
    /** Collapsing controller, same API as DateSubHeader */
    selectionFilter: { type: Object, required: true },
    setSelectionFilterFunc: { type: Function, required: true },
  },
  components: { GenericListSubHeader },

  computed: {
    // Use a unique key. If date is present, scope it to that date.
    // This matches how the parent checks collapse for two-layer.
    keyId() {
      const d = this.date ? String(this.date) : null;
      const e = this.employmentId || '—';
      return d ? `${d}::${e}` : e;
    },
    hideByKey() {
      return this.selectionFilter.hideBy?.[this.keyId] ?? false;
    },
  },

  methods: {
    toggleHideBy() {
      const copy = { ...(this.selectionFilter || {}) };
      const hideBy = { ...(copy.hideBy || {}) };
      hideBy[this.keyId] = !hideBy[this.keyId];
      copy.hideBy = hideBy;
      this.setSelectionFilterFunc(copy);
      this.$emit('checkScroll');
    },
    toggleSelected() { }, // no-op to satisfy prop contract
  },
};
</script>